import Env from 'root/lib/Env';
import store from 'a/store';
import { throwCustomAquaError } from '../activities/components/GlobalErrorHandler/actions';
import { ERROR_STRINGS } from '../activities/components/GlobalErrorHandler/constants';
import { aquaAxios, callAsyncWithRetry } from './utilityFunctions';
import { setCurriculumVersions } from '../activities/hub/actions/metaGameActions';

const { GAME_CONTENT_URL } = Env;

export const GAME_ASSET = 'gameAsset';

/**
 * Make a HTTP(S) fetch request to server to get the curriculum for a game.
 * @param gameId GameId for your game.
 * @param filename filename you would like to fetch
 * @param customPath a custom path if your curriculum lives in a path outside of the standard structure. if you are
 *    using a customPath, your custom path should also include your filename.
 * @returns {Promise<any>} returns your fetched curriculum
 */
export const fetchCurriculum = async (gameId, fileName, customPath = '') => callAsyncWithRetry(
  async () => {
    let path = `${GAME_CONTENT_URL}/${gameId}/curriculum/${fileName}`;
    if (customPath !== '') {
      path = customPath;
    }
    try {
      const { data } = await aquaAxios(path);
      return data;
    } catch (error) {
      throw error;
    }
  },
  {
    logger: (e, { isDoneRetrying }) => {
      let path = `${GAME_CONTENT_URL}/${gameId}/curriculum/${fileName}`;
      if (customPath !== '') {
        path = customPath;
      }
      if (isDoneRetrying) {
        // This API is part of loading percentage screen.
        // Clear loading UX to show Error screen
        window.reactLoaded();
        throwGlobalError(path);
      }
    },
  },
);

export const fetchCurriculumVersions = () => {
  const id = 'curriculum_versions';
  const fileName = 'CurriculumVersions.json';
  const path = `${GAME_CONTENT_URL}/${id}/${fileName}`;
  return fetchCurriculum(id, fileName, path)
    .then((curriculumVersions) => {
      store.dispatch(setCurriculumVersions(curriculumVersions));
      return curriculumVersions;
    });
};

/**
 * Make a HTTP(S) fetch request to server to get multiple curriculums at once for your game
 * @param gameId GameId for your game.
 * @param filenames array of filenames that you would like to fetch
 * @returns {Promise<any[]>} array of curriculums in the same order of the filenames you passed in.
 */
export const fetchCurriculums = (gameId, filenames) =>
  Promise.all(filenames.map(filename => fetchCurriculum(gameId, filename)));

/**
 * Dispatch action to show the global Alyx error page with "check your internet connection text"
 */
export function throwGlobalError(path) {
  const errorMessage = `CurriculumFetch.js failed to fetch your curriculum file: ${path}`;
  console.warn(errorMessage);
  store.dispatch(throwCustomAquaError({
    titleText: ERROR_STRINGS.uhOh,
    secondaryText: ERROR_STRINGS.theresBeenAnError,
    showGamesButton: false,
    showHomeButton: true,
    forceLogout: false,
    errorMessage,
    category: 'Resource: Curriculum Fetch',
    metricId: 'resource',
  }));
}
